import {useFeatureFlags} from '@github-ui/react-core/use-feature-flag'

export function useDiffInlineCommentingEnabled() {
  const {diff_inline_comments: diffInlineCommentsFeatureIsEnabled, prx_files: prxFilesIsEnabled} = useFeatureFlags()

  return diffInlineCommentsFeatureIsEnabled || prxFilesIsEnabled
}
